export default {"src":"/_next/static/media/free-estimates.f8a40392.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};